export default __webpack_public_path__ + "static/EverydayFeature-4b4df2858f7840ffeacd1be88e69d04c.webp";